import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const contentResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getContent(to.params.id as string);
        to.meta.content = res.data.data;
    } catch(error) {
        console.error('CONTENT_RESOLVER_ERROR');
        return { name: 'Contents' };
    }
}